import { StaticNavbar } from "../../dashboard/forms/improved_components/StaticNavbar";
import { WithNonAuthedTrpcClient } from "../../misc/with-non-authed-trpc-client";
import { Footer } from "./footer";

export function StaticContainer(props: { children: React.ReactNode }) {
	return (
		<div className="flex min-h-screen flex-col">
			<WithNonAuthedTrpcClient>
				<StaticNavbar />
				<div className="p-8 sm:p-0"></div>
				<div className="flex-grow">{props.children}</div>
				<div className="p-8"></div>
				<Footer />
			</WithNonAuthedTrpcClient>
		</div>
	);
}
